import { render, staticRenderFns } from "./EmployeeRecognitionView.vue?vue&type=template&id=9fbd1a6c"
import script from "./EmployeeRecognitionView.vue?vue&type=script&lang=js"
export * from "./EmployeeRecognitionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports